




































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import ItemDetailPO from "@/store/entities/basedata/itemdetailpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: { TreeSelect },
})
export default class CreateItemDetail extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "1" }) iteminfo: string;
  itemdetail: ItemDetailPO = new ItemDetailPO();
  loading: boolean = false;

  created() {
    this.itemtree();
    this.itemdetail.isEnable = 1;
  }

  create() { }
  save() {
    (this.$refs.itemDetailForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "itemdetail/create",
            data: this.itemdetail,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.error({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.loading = false;
        (this.$refs.itemDetailForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemDetailForm as any).resetFields();
    this.$emit("input", false);
  }
  async itemtree() {
    await this.$store
      .dispatch("items/getselectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => { });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  itemRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    enCode: [
      {
        required: true,
        message: this.L("Encode") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    itemId: [
      {
        required: true,
        message: this.L("FirstNode") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("iteminfo")
  getitemId() {
    this.itemdetail.itemId = this.iteminfo;
  }
}
